"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quickIdSync = exports.quickId = void 0;
const async_1 = require("nanoid/async");
const nanoid_1 = require("nanoid");
const bitsPerChar = 6;
async function quickId(bits = 256) {
    return await (0, async_1.nanoid)(Math.ceil(bits / bitsPerChar));
}
exports.quickId = quickId;
function quickIdSync(bits = 256) {
    return (0, nanoid_1.nanoid)(Math.ceil(bits / bitsPerChar));
}
exports.quickIdSync = quickIdSync;
//# sourceMappingURL=quickId.js.map